<app-add-email-replyto-list (NewEmailTrigger)="HandleNewEmailTrigger($event)"></app-add-email-replyto-list>

<ejs-grid
  [editSettings]='editSettings'
  [toolbar]='toolbar'
  [dataSource]='Emails'
  [allowPaging]="true"
  [allowSorting]="true"
  [allowFiltering]="true"
  locale="en_US"
  [filterSettings]="{type: 'CheckBox'}"
  [allowTextWrap]="true"
  [textWrapSettings]="{ wrapMode: 'Both' }"
  (beforeBatchSave)="EmailBatchSave($event)"
  #EmailsGrid
>
  <e-columns>
    <e-column field='ID' headerText='ID' textAlign='Left' [visible]="false" [allowEditing]="false"></e-column>
    <e-column field='Firstname' headerText='First Name' textAlign='Left'></e-column>
    <e-column field='Lastname' headerText='Last Name' textAlign='Left'></e-column>
    <e-column field='email' headerText='E-Mail' textAlign='Left'></e-column>
    <e-column field='Entity' headerText='Entity' textAlign='Left'></e-column>
  </e-columns>
</ejs-grid>
